module.exports = __webpack_public_path__ + "static/media/scroll4_phone4.9414186a.png";